import { render, staticRenderFns } from "./IncomingCallComponent.vue?vue&type=template&id=38782c74&scoped=true&"
import script from "./IncomingCallComponent.vue?vue&type=script&lang=js&"
export * from "./IncomingCallComponent.vue?vue&type=script&lang=js&"
import style0 from "./IncomingCallComponent.vue?vue&type=style&index=0&id=38782c74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38782c74",
  null
  
)

export default component.exports